import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { DateFormats } from '@nk/utils-lib';
import { EntityWithUuid, NkCardListItemAbstractComponent } from '../card-list.utils';

@Component({
  selector: 'nk-card-list-item-date',
  imports: [DatePipe],
  templateUrl: './card-list-item-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemDateComponent<Entity extends EntityWithUuid> extends NkCardListItemAbstractComponent<Entity> {
  public dateFormats = DateFormats;
  public value = computed(() => {
    const value = this.valueSignal();
    if (!value) {
      return null;
    }
    return value.entity[value.prop];
  });
}
